import * as React from "react";
import { RingSize } from "@spscommerce/ds-shared";
import { colors } from "@spscommerce/ds-colors";
import * as PropTypes from "../prop-types";

const propsDoc = {
  size: "RingSize"
};

const propTypes = {
  ...PropTypes.spsGlobalPropTypes,
  size: PropTypes.enumValue<RingSize>(RingSize)
};

export function SpsProgressRing(props) {
  const {
    size = RingSize.SMALL,
    progress = 0,
    foregroundColor = colors.purple200,
    backgroundColor = colors.gray300,
  } = props;
  const stroke = 4;
  const normalizedRadius = size - stroke;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="sps-progress-ring">
      <svg
        height={size * 2}
        width={size * 2}
        style={{ transform: "rotate(-90deg)" }}
      >
        <circle
          stroke={backgroundColor}
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference + " " + circumference}
          r={normalizedRadius}
          cx={size}
          cy={size}
        />
        <circle
          stroke={foregroundColor}
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference + " " + circumference}
          style={{ strokeDashoffset }}
          r={normalizedRadius}
          cx={size}
          cy={size}
        />
      </svg>
    </div>
  );
}
Object.assign(SpsProgressRing, {
  props: propsDoc,
  propTypes,
  displayName: "SpsProgressRing"
});
